import dayjs from 'dayjs';
import { FilterOperator } from '@progress/kendo-data-query';
import {
  SearchFolder,
  CpsUserAllowedActions,
  CPS_ACTIONS_ALLOWED_FOR_DOCUMENT,
  CpsFieldTypeToFilterType,
  CpsFilterRequest,
  CPS_FIELD_TYPE
} from '@cs-cms/types';
import { getGearDateTimeFilterFormat } from '@cs-cms/utils';

export const areQueryFiltersEqual = (a: CpsFilterRequest[] | undefined, b: CpsFilterRequest[] | undefined): boolean => {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    const f1 = a[i];
    const f2 = b[i];

    if (
      f1.fieldName !== f2.fieldName ||
      f1.operator !== f2.operator ||
      f1.fieldType !== f2.fieldType ||
      f1.values.length !== f2.values.length
    ) {
      return false;
    }

    for (let j = 0; j < f1.values.length; j++) {
      if (f1.values[j] !== f2.values[j]) {
        return false;
      }
    }
  }

  return true;
};

export const getDateTimeRangeFilters = (date: Date, fieldName: string): CpsFilterRequest[] => {
  const localDate = dayjs(date);
  const startOfDay = localDate.startOf('day');
  const endOfDay = localDate.endOf('day');

  return [
    {
      fieldName,
      operator: 'gte' as FilterOperator,
      values: [getGearDateTimeFilterFormat(startOfDay.toDate())],
      fieldType: CpsFieldTypeToFilterType(CPS_FIELD_TYPE.DATETIME)
    },
    {
      fieldName,
      operator: 'lte' as FilterOperator,
      values: [getGearDateTimeFilterFormat(endOfDay.toDate())],
      fieldType: CpsFieldTypeToFilterType(CPS_FIELD_TYPE.DATETIME)
    }
  ];
};

export const getOperatorLabel = (operator: FilterOperator): string => {
  switch (operator) {
    case 'eq':
      return '';
    case 'neq':
      return '≠';
    case 'lt':
      return '<';
    case 'lte':
      return '≤';
    case 'gt':
      return '>';
    case 'gte':
      return '≥';
    case 'contains':
      return 'contains';
    case 'doesnotcontain':
      return 'does not contain';
    case 'startswith':
      return 'starts with';
    case 'endswith':
      return 'ends with';
    default:
      return '';
  }
};

export const getSearchResultKey = (folder: SearchFolder, searchKey?: string) => {
  return `${folder?.id || ''}_${searchKey || ''}`;
};

export const getActionsFromFlag = (flag: number): CpsUserAllowedActions[] => {
  const actions: CpsUserAllowedActions[] = [];

  for (const action of Object.keys(CPS_ACTIONS_ALLOWED_FOR_DOCUMENT)) {
    const actionValue = CPS_ACTIONS_ALLOWED_FOR_DOCUMENT[action as keyof typeof CPS_ACTIONS_ALLOWED_FOR_DOCUMENT];
    if (typeof actionValue === 'number' && (flag & actionValue) === actionValue) {
      actions.push(actionValue);
    }
  }

  return actions;
};
